/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  document.addEventListener('theme:cart:added', (e) => {
    console.log('[Cart] refreshed (event)', e.detail);
    updateProgressBar();
    updateEconomyField();
  });

  document.addEventListener('theme:cart:update', (e) => {
    console.log('[Cart] quantity change requested', e.detail);
    updateProgressBar();
    updateEconomyField();
  });

  const formatMoney = (amount) => {
    const browserLocale = navigator.language || 'en-US';
    const currency = window.Shopify?.currency?.active || 'USD';

    if (amount === 0) {
      return 'OFFERT';
    }

    return new Intl.NumberFormat(browserLocale, {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100);
  };

  const updateEconomyField = () => {
    console.log('updateEconomyField');
    const economyFieldContainer = document.querySelector('[data-economy-field]');
    if (!economyFieldContainer) return;

    const economyField = economyFieldContainer.querySelector('.value');
    if (!economyField) return;

    const cartItemsContainer = document.getElementById('cartItemsHolder');

    const items = cartItemsContainer.querySelectorAll('.cart__item');

    let cartPreviousValueInCents = 0;
    items.forEach((item) => {
      const itemPriceElContainer = item.querySelector('.cart__item__price');
      const itemPriceEl = itemPriceElContainer.lastChild;
      let itemPrice = 0;
      if (itemPriceEl) {
        itemPrice = parseFloat(itemPriceEl.textContent.replace('€', '').replace(',', '.'));
      }
      const itemQuantity = parseInt(item.querySelector('[data-quantity-field]').value, 10);
      cartPreviousValueInCents += itemPrice * itemQuantity;

      console.log("updateEconomyField", "item", item, { itemPriceElContainer, itemPriceEl, itemPrice, itemQuantity });
    });
    cartPreviousValueInCents = cartPreviousValueInCents * 100;

    const cartValueCents = parseFloat(document.querySelector('[data-cart-checkout-buttons] [data-cart-total-price]').textContent.replace('€', '').replace(',', '.')) * 100;
    console.log("updateEconomyField", "cartValueCents", cartValueCents, "cartPreviousValueInCents", cartPreviousValueInCents);

    const economyValue = cartPreviousValueInCents - cartValueCents;
    if (economyValue > 0) {
      economyField.textContent = formatMoney(economyValue);
      economyFieldContainer.classList.remove('hidden');
    } else {
      economyField.textContent = '0';
      economyFieldContainer.classList.add('hidden');
    }
  }

  const updateProgressBar = () => {
    const progressRoot = document.querySelector('[data-cart-progress]');
    if (!progressRoot) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        const cartValueCents = typeof cart?.total_price === 'number' ? cart.total_price : 0;

        const stepNodes = progressRoot.querySelectorAll('.Cart__ProgressStep');
        stepNodes.forEach((stepNode) => {
          const stepValue = parseInt(stepNode.getAttribute('data-step-cents') || '0', 10);
          const prevValue = parseInt(stepNode.getAttribute('data-prev-cents') || '0', 10);
          const fill = stepNode.querySelector('.Cart__ProgressStepBarFill');
          if (!fill) return;

          let percentage = 0;
          if (cartValueCents >= stepValue) {
            percentage = 100;
          } else if (cartValueCents > prevValue) {
            const start = stepValue - prevValue || 1;
            percentage = ((cartValueCents - prevValue) / start) * 100;
          } else {
            percentage = 0;
          }
          fill.style.setProperty('--width', `${Math.max(0, Math.min(100, percentage))}%`);
        });

        const headerEl = progressRoot.querySelector('.Cart__ProgressHeaderLabel');
        if (headerEl) {
          let headerText = headerEl.textContent;
          const steps = Array.from(stepNodes).map((node) => ({
            step: parseInt(node.getAttribute('data-step-cents') || '0', 10),
            prev: parseInt(node.getAttribute('data-prev-cents') || '0', 10),
            notReached: node.getAttribute('data-not-reached-text') || '',
            reached: node.getAttribute('data-reached-text') || '',
          }));

          steps.sort((a, b) => a.step - b.step);

          for (let i = 0; i < steps.length; i += 1) {
            const s = steps[i];
            if (cartValueCents < s.prev) break;
            if (cartValueCents < s.step) {
              const remaining = s.step - cartValueCents;
              const formatted = formatMoney(remaining);
              headerText = (s.notReached || '').replace('#{remaining}', formatted);
              break;
            } else {
              headerText = s.reached || headerText;
            }
          }

          headerEl.textContent = headerText;
        }
      })
      .catch(() => {
        // silent
      });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

(function () {
  console.log('Cart timer initialized');

  let _timer = null;

  function update() {
    const root = document.querySelector('[data-karacare-cart-timer]');
    if (!root) return;

    let year = parseInt(root.dataset.year);
    let month = parseInt(root.dataset.month);
    let day = parseInt(root.dataset.day);
    let hour = parseInt(root.dataset.hour);
    let minute = parseInt(root.dataset.minute);

    console.log(year, month, day, hour, minute);

    const _date = new Date(Date.UTC(year, month - 1, day, hour, minute, 0, 0));

    const now = new Date();
    const diff = _date.getTime() - now.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    root.querySelector('.karacare-timer__num[data-t="days"]').textContent = days;
    if (days <= 0) {
      root.querySelector('.karacare-timer__token--days').classList.add('hidden');
    } else {
      root.querySelector('.karacare-timer__token--days').classList.remove('hidden');
    }
    root.querySelector('.karacare-timer__num[data-t="hours"]').textContent = hours;
    root.querySelector('.karacare-timer__num[data-t="minutes"]').textContent = minutes;
    root.querySelector('.karacare-timer__num[data-t="seconds"]').textContent = seconds;

    if (diff <= 0) {
      clearInterval(_timer);
      root.classList.add('karacare-timer--ended');
    }
  }

  function init() {
    _timer = setInterval(() => {
      update();
    }, 1000);
  }

  init();
})();

// Dialog snippet for updating cart
(function () {
  // Listen for the "dialog:cart:updated" event on the document
  document.addEventListener("dialog:cart:updated", function (event) {
    window.cart.openCartDrawer()
    setTimeout(() => window.cart.getCart(), 2000)
  });
})();